import blues from "./index.es4.js";
import greens from "./index.es5.js";
import greys from "./index.es6.js";
import navys from "./index.es7.js";
import oranges from "./index.es8.js";
import reds from "./index.es9.js";
import steels from "./index.es10.js";
import white from "./index.es11.js";
const colors = {
  ...blues,
  ...reds,
  ...greens,
  ...greys,
  ...navys,
  ...oranges,
  ...steels,
  ...white
};
const getColor = (color) => colors[color];
export {
  colors,
  getColor
};
//# sourceMappingURL=index.es2.js.map
